import styles from './Jeemocktest.module.css'
import OnlineMode from '../../assets/offline_mode_icon.svg'
import TestPrepIcon from '../../assets/jee_test_prep_icon.svg'

const JeeTestCriteria = () => {
    return (
        <div className='container'>
            <div className={`${styles.jeetestwrapper}`}>
                <div className={`${styles.jeetcheading}`}>
                    <h2>Test details</h2>
                </div>
                <div className={`${styles.jeewappertest}`}>
                    <div className={`${styles.jee_test_box} ${styles.jee_blue_box}`}>
                        <img src={TestPrepIcon} alt="test prep"/>
                        <h3>Test Mode</h3>
                        <p>Online Mode</p>
                    </div>
                    <div className={`${styles.jee_test_box} ${styles.jee_pink_box}`}>
                        <img src={OnlineMode} alt="calendar" />
                        <h3>Registration Fee - Rs 0</h3>
                        <p>Absolutely Free</p>
                    </div>
                    <div className={`${styles.jee_test_box} ${styles.jee_darkpink_box}`}>
                        <img src="https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/time-icon2.svg" alt="online mode"/>
                        <h3>Exam Dates</h3>
                        <p><strong>20th July</strong> - JEE Mains Open Test</p>
                        <p><strong>27th July</strong> - JEE Advanced Open Test</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default JeeTestCriteria